module.exports = __webpack_public_path__ + "img/logo.e2837cc8.png";